<div class="portal-redirect-wrapper">
  <div class="row text-center">
    <div class="col-12">
      <h1 class="harmony-secondary-text fw-bold">
        The <span class="registered">Harmony</span> Portal has moved to a new URL
      </h1>
    </div>
  </div>
  <br>
  <div class="row text-center">
    <div class="col-12">
      <button class="btn btn-primary harmony-accent-coral-button"
              (click)="navigateToPortal()">
        Go to Portal
      </button>
    </div>
  </div>
</div>
